import { render, staticRenderFns } from "./FeeBreakdownChart.vue?vue&type=template&id=a3741fc0&"
import script from "./FeeBreakdownChart.vue?vue&type=script&lang=ts&"
export * from "./FeeBreakdownChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports